// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"8a1cb42b","230":"28772593","239":"2c1e6e7b","326":"2f850525","338":"ff215e22","397":"d50467f2","453":"69b729f2","707":"a51c51dd","876":"4091784a"}[chunkId] + ".chunk.js";
};